import { BaseService } from "./base.service";
import { detect } from "detect-browser";

export class PurlTrackingService extends BaseService {
  static async purlVisit(purl = "") {
    try {
      const post = {
        method: "visit",
        purl,
      };
      const response = await this.request().post(
        `${process.env.VUE_APP_API_TRACKING_PATH}`,
        post
      );
      return response.data.sessionDbId;
    } catch (e) {
      throw new Error("Server error: Tracking is not working.");
    }
  }
  static async trackPage(purl, sessionDbId, sectionId) {
    const post = {
      method: "page",
      purl,
      sessionDbId,
      section: sectionId,
    };
    try {
      this.request().post(`${process.env.VUE_APP_API_TRACKING_PATH}`, post);
    } catch (e) {
      throw new Error("Server error: Tracking is not working.");
    }
  }
}
